exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.fmt-popup h3{\n  margin: 8px 0;\n}\n.fmt-popup{\n  display:none;\n  max-width: 400px;\n  text-align: left;\n  line-height:1;\n  font-size: 0.9rem;\n}\n.leaflet-popup-content .fmt-popup{\n  display: block;\n}\n.fmt-popup img{\n  float: left;\n  margin-right: 5px;\n  margin-bottom: 0px;\n}\n", ""]);

